import { defineStore } from 'pinia'

export const useBookableStore = defineStore({
  id: 'bookable',
  state: () => ({
    bookables: [],
  }),
  getters: {
    findById: (state) => (id) => state.bookables.find(find => find.id === id),
    findByIds: (state) => (ids) => state.bookables.filter(find => ids.includes(find.id)),
  },
})
